import { createSlice } from '@reduxjs/toolkit';
import config from '../../config';
import { ITag } from '../../interfaces/Iot';

type IOTState = {
	serverAddress: string;
	tags?: ITag[];
	subscriptionKeys: any;
	subscriptionKeysToVariables: any;
	connected?: boolean;
	isEditorOpen: boolean;
	variableToSubscriptionKey: any;
};

const initialState: IOTState = {
	serverAddress: config.IOT_SERVER_ADDRESS || "",
	tags: [],
	subscriptionKeys: {},
	subscriptionKeysToVariables: {},
	connected: false,
	isEditorOpen: false,
	variableToSubscriptionKey: {},
};

// TODO: fill in all the types!
const IOTSlice = createSlice({
	name: "iot",
	initialState: { ...initialState },
	reducers: {
		setTagList(state, action) 
		{
			state.tags = action.payload;
		},
		setTag(state, action) 
		{
			if(!state.tags)
			{
				state.tags = [];
			}
			
			for (let i = 0; i < state.tags.length; i++) 
			{
				const tag = state.tags[i];
				if (tag.name === action.payload.name
					&& tag.topic === action.payload.topic
					&& tag.device === action.payload.device) 
				{
					state.tags[i] = action.payload;
				}
			}
		},
		addSubscriptionKey(state, action) 
		{
			state.subscriptionKeys[action.payload.key] = action.payload.value;
			state.subscriptionKeysToVariables[action.payload.key] = action.payload.variable;
		},
		removeSubscriptionKey(state, action) 
		{
			delete state.subscriptionKeys[action.payload];
			delete state.subscriptionKeysToVariables[action.payload];
		},
		clearSubscriptionKeys(state, action)
		{
			state.subscriptionKeys = {};
			state.variableToSubscriptionKey = {};
		},
		loadIOTData(state, action) 
		{
			if (action.payload) 
			{
				state.subscriptionKeys = action.payload.subscriptionKeys;
				state.subscriptionKeysToVariables = action.payload.subscriptionKeysToVariables ?? {};
			}
		},
		setConnected(state, action) 
		{
			state.connected = action.payload;
		},
		setEditorOpen(state, action) 
		{
			state.isEditorOpen = action.payload;
		},
	},
});

export default IOTSlice;